// @ts-nocheck
import { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import { LoadingOverlayProps } from "@insite/mobius/LoadingOverlay";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { ProductPriceStyles } from "@store/Overrides/Components/ProductPrice";
import { tableProps } from "@store/Themes/common/props/table";
import { getLoadingOverlayProps } from "@store/Themes/common/props/loadingOverlay";
import { css } from "styled-components";

export interface StoreProductTableProps {
    loadingOverlay?: LoadingOverlayProps;
    noResults?: TypographyPresentationProps;
    tableWrapper?: InjectableCss;
    tableCellDescription?: DataTableCellProps;
    tableCellQuantity?: DataTableCellProps;
    tableCellControls?: DataTableCellProps;
    itemNote?: TypographyPresentationProps;
    globalNote?: TypographyPresentationProps;
    itemControls?: InjectableCss;
    itemPrice?: ProductPriceStyles;
}

export const productTableProps: StoreProductTableProps = {
    loadingOverlay: getLoadingOverlayProps(),
    noResults: {
        forwardAs: "p",
    },
    tableWrapper: tableProps?.wrapper,
    tableCellDescription: {
        css: css`
            width: 100%;
        `,
    },
    tableCellQuantity: {
        css: css`
            text-align: center;
        `,
    },
    tableCellControls: {
        css: css`
            padding-top: 0.5em;
            padding-right: 0.5em;
            padding-bottom: 0.5em;
        `,
    },
    itemControls: {
        css: css`
            display: inline-flex;
            justify-content: flex-end;
        `,
    },
    itemNote: {
        css: css`
            display: block;
            text-align: center;
            font-weight: ${x => x.theme.design.typography.weight.bold};
            color: ${getColor("text.accent")};
        `,
    },
    globalNote: {
        css: css`
            display: block;
            margin-top: 0.5em;
            font-style: italic;
            font-size: ${x => x.theme.design.typography.size.smaller};
            color: ${getColor("text.accent")};
        `,
    },
};
